var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196f3",
    d: "M40,5H8C6.343,5,5,6.343,5,8v35l9-8h26c1.657,0,3-1.343,3-3V8C43,6.343,41.657,5,40,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3f2fd",
    d: "M15 18A2 2 0 1 0 15 22 2 2 0 1 0 15 18zM24 18A2 2 0 1 0 24 22 2 2 0 1 0 24 18zM33 18A2 2 0 1 0 33 22 2 2 0 1 0 33 18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d74b2b0bc8c6c661f072983168930d6b.svg";
export { ForwardRef as ReactComponent };